import Hero from "../HeroSection/Hero";
import WelcomeSection from '../WelcomeSection/WelcomeSection';
import Capabilities from '../Capabilities/Capabilities';
import Industries from '../Industries/Industries';
import WhyChoose from '../WhyChoose/WhyChoose';
import ProductRange from '../ProductRange/ProductRange';

function Home () {

    return(

        <>
    <Hero/>
    <WelcomeSection/>
    <Capabilities/>
    <Industries/>
    <WhyChoose/>
    <ProductRange/>
        
        </>
    )


}

export default Home;